module.exports = __webpack_public_path__ + "img/img6.caa6908d.svg";